import { GetterTree } from "vuex";
import { RootState } from "@/store/types";

import { ThemeState } from "../types";

const getters: GetterTree<ThemeState, RootState> = {
  getAccentColor: (state) => state.accentColor,
  getSecondaryColor: (state) => state.secondaryColor,
  getGradient: (state) => state.gradient,
  getFontFamily: (state) => state.fontFamily,
  getIsCustomizationEnabled: (state) => state.isCustomizationEnabled,
  getIllustrations: (state) => state.illustrations,
};

export default getters;
